module.exports = __webpack_public_path__ + "img/UVC3.cb40cb85.png";